module.exports = __webpack_public_path__ + "img/icon-valor-bruto.49c8727e.svg";